import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import Loader from '../../components/Loader';
import { registerGuestAccount } from '../../redux/Reducers/commonApis';
import passwordEye from '../../images/passwordeye.png';
import toast from 'react-hot-toast';
import CreateOrderGroup from './CreateOrderGroup';
import { phone_add_plus_one } from '../../utils/commonUtil';
import PhoneField from '../../components/PhoneField';
import { getProfileDataApi } from '../../redux/Reducers/ProfileReducer';
import { getAllServiceAddressesApi } from '../../redux/Reducers/ServiceAddressesReducer';
import { useDispatch, useSelector } from 'react-redux';
import OrderPlaced from './OrderPlaced';
import { useNavigate } from 'react-router-dom';

function GroupAccountDetails({ token, loading }) {
  const navigate = useNavigate();
  const tenantName = import.meta.env.VITE_TENANT_NAME;
  const tenant = import.meta.env.VITE_TENANT_NAME;
  const { groupData } = useSelector((state) => state.group);
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({});
  const [registerLoading, setRegisterLoading] = useState(false);
  const validateName = (name) => !!name && name.trim().length > 0;
  const validateUSPhone = (phone) => {
    if (!phone) return false;
    const digits = (phone || '').replace(/\D/g, '');
    const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    return /^[2-9][0-8][0-9][2-9][0-9]{2}[0-9]{4}$/.test(ten);
  };
  const validatePassword = (password) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validateEmail = (email) => !!email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const registerGuestAccountFn = (type) => {
    const payloadEmail = {
      email: formData?.email,
      validate_email: true,
      address: {
        address_line_1: groupData?.address_line_1,
        city: groupData?.city,
        state: groupData?.state,
        postal_code: groupData?.postal_code,
      },
    };
    const payloadEmailAccount = {
      email: formData?.email,
      address: {
        address_line_1: groupData?.address_line_1,
        city: groupData?.city,
        state: groupData?.state,
        postal_code: groupData?.postal_code,
      },
      first_name: formData.firstName,
      last_name: formData.lastName,
      password: formData.password,
      confirm_password: formData.password,
      phone_number: { phone_number: formData?.phoneNumber },
    };
    if (groupData?.group_account_type !== 'HOTEL') {
      delete payloadEmailAccount.address;
      delete payloadEmail.address;
    }
    setRegisterLoading(true);
    const response = registerGuestAccount(token, type === 'email' ? payloadEmail : payloadEmailAccount);
    response?.then((res) => {
      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        if (step == 2) {
          if (res?.data) {
            res.data.refresh_expires_date = new Date(new Date().getTime() + res?.data?.refresh_expires_in * 1000);
            localStorage.setItem('auth', JSON.stringify(res?.data));
            dispatch(getAllServiceAddressesApi());
            const getProfileData = dispatch(getProfileDataApi());
            getProfileData?.then((res) => {
              if (res?.status === 200) {
                setRegisterLoading(false);
                if (groupData?.group_account_type === 'HOTEL') {
                  setStep(3);
                } else {
                  navigate('/dashboard');
                }
              }
            });
          }
        } else {
          setRegisterLoading(false);
          setStep(2);
        }
      } else {
        //if res.messages has 'already exists' then set step to 2
        if (res?.messages?.includes('already exists')) {
          toast.error(res?.messages || 'Something went wrong');
          setRegisterLoading(true);
          //redirect to /signin
          setTimeout(() => {
            window.location = '/signin';
          }, 2000);
        } else {
          setRegisterLoading(false);
          toast.error(res?.messages || 'Something went wrong');
        }
      }
    });
  };
  const handleAccountNext = () => {
    const newErrors = {};
    if (!validateName(formData.firstName)) newErrors.firstName = 'First name is required';
    if (!validateName(formData.lastName)) newErrors.lastName = 'Last name is required';
    if (!validatePassword(formData.password))
      newErrors.password =
        'Password must be at least 8 characters, include upper and lower case letters, and at least one number';
    if (!validateUSPhone(formData.phoneNumber)) newErrors.phoneNumber = 'Enter a valid US phone number';
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      registerGuestAccountFn('account');
    }
  };
  return (
    <div className='flex h-[100dvh] overflow-hidden'>
      <div className='relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden'>
        <main className='grow bg-[#01235A]'>
          <header className='bg-white text-center'>
            <div className='inline-flex py-4 sm:mb-0'>
              {loading ? (
                <div className='flex h-40 w-40 items-center justify-center rounded-lg bg-gray-300'>
                  <svg
                    className='h-10 w-10 text-gray-200'
                    aria-hidden='true'
                    xmlns='http://www.w3.org/2000/svg'
                    fill='currentColor'
                    viewBox='0 0 20 18'
                  >
                    <path d='M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z' />
                  </svg>
                </div>
              ) : (
                <img className='flex h-40 items-center justify-center' src={groupData?.profile_image_url} />
              )}
            </div>
            <div className='w-full bg-black px-4 py-4 text-white sm:px-6  lg:px-8'>
              <div className='mx-auto max-w-3xl'>
                <div className='mb-2 flex items-center justify-center'>
                  {loading ? (
                    <div>
                      <div className='mb-4 h-2.5 w-48 rounded-full bg-gray-200'></div>
                      <div className='h-2 w-32 rounded-full bg-gray-200'></div>
                    </div>
                  ) : (
                    <h2 className='text-2xl font-bold '>{groupData?.group_account_name}</h2>
                  )}
                </div>
              </div>
            </div>
          </header>
          <div className='mx-auto  max-w-md justify-center   '>
            <div className='  p-6'>
              <section>
                {loading ? (
                  <div className='flex justify-center'>
                    <div className='mb-1 h-4 w-48 rounded-full bg-gray-200'></div>
                  </div>
                ) : (
                  <p className=' mb-1  text-center text-xl font-bold text-white'>
                    {step == 4
                      ? 'Order Placed'
                      : groupData?.group_account_type == 'HOTEL'
                      ? 'Schedule A Pickup'
                      : 'Create Your Account'}
                  </p>
                )}
                {step === 1 && (
                  <div className='mt-5 flex flex-col space-y-4 rounded-lg bg-white sm:flex sm:items-center'>
                    {registerLoading ? (
                      <Loader text='Checking...' classes='h-56' />
                    ) : (
                      <div className='w-full'>
                        <div className='p-8'>
                          {loading ? (
                            <div className=' mb-6'>
                              <div className='mb-2 h-2 w-48 rounded-full bg-gray-200'></div>
                              <div className='h-2 w-20 rounded-full bg-gray-200'></div>
                            </div>
                          ) : (
                            <p className='text-client-800 mb-4 font-semibold'>
                              Get started by entering <br></br>your email
                            </p>
                          )}
                          {loading ? (
                            <div className=' mb-4'>
                              <div className='mb-2 h-2 w-12 rounded-full bg-gray-200'></div>
                              <div className='mb-2 h-8 w-full rounded-lg bg-gray-200'></div>
                            </div>
                          ) : (
                            <div className='mb-2 w-full'>
                              <label className='go-label-15 mb-1 block text-sm font-medium' htmlFor='location'>
                                Email:
                              </label>
                              <input
                                id='email'
                                className='form-input w-full'
                                type='text'
                                value={formData.email || ''}
                                onChange={(e) => {
                                  setFormData({ ...formData, email: e.target.value });
                                  setTouched({ ...touched, email: true });
                                  setErrors({
                                    ...errors,
                                    email:
                                      !validateEmail(e.target.value) && e.target.value
                                        ? 'Enter a valid email address'
                                        : undefined,
                                  });
                                }}
                                onBlur={() => setTouched({ ...touched, email: true })}
                                required
                              />
                              {touched.email && errors.email && <p className='text-xs text-red-500'>{errors.email}</p>}
                            </div>
                          )}
                        </div>
                        <footer>
                          <div className='flex flex-col px-6 pb-5'>
                            <div className='flex self-end align-middle'>
                              {loading ? (
                                <div className=''>
                                  <div className='mb-2 h-4 w-14 rounded-lg bg-gray-200'></div>
                                </div>
                              ) : (
                                <button
                                  className='text-client-link font-semibold'
                                  onClick={() => {
                                    registerGuestAccountFn('email');
                                  }}
                                  disabled={!formData?.email || !validateEmail(formData.email) || registerLoading}
                                >
                                  Next
                                  <ArrowRightIcon className='ml-2 inline-block h-7' />
                                </button>
                              )}
                            </div>
                          </div>
                        </footer>
                      </div>
                    )}
                  </div>
                )}
                {step === 2 && (
                  <div className='mt-5 flex w-full flex-col space-y-4 rounded-lg bg-white '>
                    {registerLoading ? (
                      <Loader text='Checking...' classes='h-56' />
                    ) : (
                      <div className='w-full'>
                        <div className='p-8'>
                          <p className='text-client-800 mb-6 font-semibold'>Create your account</p>
                          <div className='mb-2 w-full'>
                            <label className='go-label-15 mb-1 block text-sm font-medium' htmlFor='firstName'>
                              First Name
                            </label>
                            <input
                              id='firstName'
                              className='form-input w-full'
                              type='text'
                              value={formData.firstName || ''}
                              onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                            />
                            {errors.firstName && <p className='text-xs text-red-500'>{errors.firstName}</p>}
                          </div>
                          <div className='mb-2 w-full'>
                            <label className='go-label-15 mb-1 block text-sm font-medium' htmlFor='lastName'>
                              Last Name
                            </label>
                            <input
                              id='lastName'
                              className='form-input w-full'
                              type='text'
                              value={formData.lastName || ''}
                              onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                            />
                            {errors.lastName && <p className='text-xs text-red-500'>{errors.lastName}</p>}
                          </div>
                          <div className='relative mb-2 w-full'>
                            <label className='go-label-15 mb-1 block text-sm font-medium' htmlFor='passwordField'>
                              Password
                            </label>
                            <input
                              id='passwordField'
                              className='form-input w-full'
                              type={showPassword ? 'text' : 'password'}
                              value={formData.password || ''}
                              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                              autoComplete='new-password'
                              onBlur={() => setTouched({ ...touched, password: true })}
                              required
                            />
                            <img
                              src={passwordEye}
                              alt='eye'
                              className='absolute  -right-1 top-6 h-10 w-12'
                              onClick={() => setShowPassword(!showPassword)}
                            />
                            {errors.password ? (
                              <p className='text-xs text-red-500'>{errors.password}</p>
                            ) : (
                              <p className='text-xs text-gray-500'>
                                <span className='text-red-500'>*</span>
                                Password must be at least 8 characters, include upper and lower case letters, and at
                                least one number
                              </p>
                            )}
                          </div>
                          <div className='mb-2 w-full'>
                            <label className='go-label-15 mb-1 block text-sm font-medium' htmlFor='phoneNumber'>
                              Phone number
                            </label>
                            <PhoneField
                              id='phoneNumber'
                              name='phoneNumber'
                              className='form-input w-full'
                              value={formData.phoneNumber || ''}
                              onChange={(e, apiValue) => {
                                const valueToSet = apiValue || (e && e.target ? e.target.value : '');
                                setFormData({ ...formData, phoneNumber: valueToSet });
                              }}
                              placeholder='(555) 555-5555'
                            />
                            {errors.phoneNumber && <p className='text-xs text-red-500'>{errors.phoneNumber}</p>}
                            <p className='text-xs text-gray-500'>
                              By selecting next, you agree to receive service and marketing auto-sent texts from{' '}
                              {tenantName == 'laundrycare' ? 'Laundry Care' : 'Push Laundry'}. Opt-out anytime on your
                              “My Account” page or text “STOP”. Message & data rates may apply. By continuing, you also
                              agree to our{' '}
                              <a
                                href={
                                  tenant == 'laundrycare'
                                    ? 'https://www.laundrycare.biz/tos/'
                                    : 'https://pushlaundry.com/tos/'
                                }
                                className='text-[#548ff7]'
                                target='_blank'
                              >
                                Terms of Service
                              </a>{' '}
                              and{' '}
                              <a
                                href={
                                  tenant == 'laundrycare'
                                    ? 'https://www.laundrycare.biz/privacy/'
                                    : 'https://www.pushlaundry.com/privacy-policy/'
                                }
                                className='text-[#548ff7]'
                                target='_blank'
                              >
                                Privacy Policy
                              </a>
                              .
                            </p>
                          </div>
                        </div>
                        <footer>
                          <div className='flex flex-col px-6 pb-5'>
                            <div className='flex self-end align-middle'>
                              <button
                                className='text-client-link font-semibold'
                                onClick={() => {
                                  handleAccountNext();
                                }}
                              >
                                Next
                                <ArrowRightIcon className='ml-2 inline-block h-7' />
                              </button>
                            </div>
                          </div>
                        </footer>
                      </div>
                    )}
                  </div>
                )}
                {step === 3 && <CreateOrderGroup setStep={setStep} />}
                {step === 4 && <OrderPlaced />}
              </section>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default GroupAccountDetails;
